import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CarrierMarketplaceMappingRequestModel } from '../models/request-models/carrier-marketplace-mapping-request.model';
import { CarrierMarketplaceMappingResponseModel } from '../models/response-models/carrier-marketplace-mapping-response.model';

@Injectable({
  providedIn: 'root',
})
export class CarrierMarketplaceMappingsApiService {
  private readonly BASE: string = `${environment.inventoryApiUrl}/CarrierMarketplaceMappings`;

  private readonly GET_ALL = (): string => `${this.BASE}`;
  private readonly GET_BY_ID = (id: number): string => `${this.BASE}/${id}`;
  private readonly CREATE = (): string => `${this.BASE}`;
  private readonly UPDATE = (id: number): string => `${this.BASE}/${id}`;
  private readonly DELETE = (id: number): string => `${this.BASE}/${id}`;

  constructor(private readonly http: HttpClient) {}

  getCarrierMarketplaceMappings(
    queryParams: Record<string, string | number | boolean>,
  ): Observable<CarrierMarketplaceMappingResponseModel[]> {
    const params: HttpParams = new HttpParams({ fromObject: queryParams });
    return this.http.get<CarrierMarketplaceMappingResponseModel[]>(this.GET_ALL(), { params });
  }

  getCarrierMarketplaceMappingById(id: number): Observable<CarrierMarketplaceMappingResponseModel> {
    return this.http.get<CarrierMarketplaceMappingResponseModel>(this.GET_BY_ID(id));
  }

  createCarrierMarketplaceMapping(
    payload: CarrierMarketplaceMappingRequestModel,
  ): Observable<CarrierMarketplaceMappingResponseModel> {
    return this.http.post<CarrierMarketplaceMappingResponseModel>(this.CREATE(), payload);
  }

  updateCarrierMarketplaceMapping(
    id: number,
    payload: CarrierMarketplaceMappingRequestModel,
  ): Observable<CarrierMarketplaceMappingResponseModel> {
    return this.http.put<CarrierMarketplaceMappingResponseModel>(this.UPDATE(id), payload);
  }

  deleteCarrierMarketplaceMapping(id: number): Observable<void> {
    return this.http.delete<void>(this.DELETE(id));
  }
}
